module.exports = __webpack_public_path__ + "static/media/orquestra_salao_6.dd660c00.jpg";